import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible/flexible'
import '@/router/router.guard' // 全局路由守卫
import loading from '@/components/Loading'

Vue.config.productionTip = false
Vue.use(loading)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
